import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../MyComponents/Footer";
// import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
import heroContent from "./HeroContent";
// import leftimgs from "../../assets/quranLeftImg.png";
// import rightimgs from "../../assets/quranRightImg.png";
// import QuranImg1 from "../../assets/QuranImg1.png";
// import QuranImg2 from "../../assets/QuranImg2.png";
// import QuranImg3 from "../../assets/QuranImg3.png";
// import QuranImg4 from "../../assets/QuranImg4.png";
// import QuranImg5 from "../../assets/QuranImg5.png";
// import QuranImg6 from "../../assets/QuranImg6.png";
// import CourseExplorer from "../../MyComponents/CourseExplorer";
import LearningStyle from "../../MyComponents/LearningStyle";
import Testimonials from "../../MyComponents/Testimonials";
import FAQs from "../../MyComponents/FooterPages/newfaq";
import HeadSection from "../HeadSection.js";
// import pencilIcon from "../assets/pencil.png";
import API_CONFIG from "../../config/api";
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import { Link } from "react-router-dom";
// import img1 from "../../assets/Quran Courses/Group 22.png"
// import img2 from "../../assets/Quran Courses/Group 22-1.png"
// import img3 from "../../assets/Quran Courses/Rectangle 5.png"
// import img4 from "../../assets/Quran Courses/Rectangle 5-1.png"
// import img5 from "../../assets/Quran Courses/Rectangle 5-2.png"
// import img6 from "../../assets/Quran Courses/Group 22-2.png"


// import icon1 from "../../assets/Quran Courses/Group 1686551984.png"
// import icon2 from "../../assets/Quran Courses/Group 1686552228.png"
// import icon3 from "../../assets/Quran Courses/Group 1686552233.png"
// import icon4 from "../../assets/Quran Courses/Clip path group-2.png"
// import icon5 from "../../assets/Quran Courses/Group.png"
// import icon6 from "../../assets/Quran Courses/Group 1686552229.png"
import { Helmet } from "react-helmet";


const courses = [
  {
    title: "Yassarnal Qur'an",
    image: "Polymath-images/Quran Courses/Group 22.png",
    icon: "Polymath-images/Quran Courses/Group 1686551984.png",
    color: "#d4149aff",
    age: "Age: 12+",
    // link: "/graphic_designing_adobexd"
  },
  {
    title: "Qur'an Recitation",
    image: "Polymath-images/Quran Courses/Group 22-1.png",
    icon: "Polymath-images/Quran Courses/Group 1686552228.png",
    color: "#9956bbff",
    age: "Age: 12+",
    // link: "/graphic_designing_corel" 
  },
  {
    title: "Tafseer-ul-Qur'an",
    image: "Polymath-images/Quran Courses/Rectangle 5.png",
    icon: "Polymath-images/Quran Courses/Group 1686552233.png",
    color: "#66c0ccff",
    age: "Age: 12+",
    // link: "/coding_web_development"
  },
  {
    title: "Learn Surahs by Heart",
    image: "Polymath-images/Quran Courses/Rectangle 5-1.png",
    icon: "Polymath-images/Quran Courses/Clip path group-2.png",
    color: "#1f7c08ff",
    age: "Age: 12+",
    // link: "/graphic_designing_canva" 
  },
  {
    title: "Islamic Knowledge Course",
    image: "Polymath-images/Quran Courses/Rectangle 5-2.png",
    icon: "Polymath-images/Quran Courses/Group.png",
    color: "#ffde24ff",
    age: "Age: 12+",
    link: "/quran_islamic_knowledge"
  },
  {
    title: "Hifz ul Qur'an",
    image: "Polymath-images/Quran Courses/Group 22-2.png",
    icon: "Polymath-images/Quran Courses/Group 1686552229.png",
    color: "#d4149aff",
    age: "Age: 12+",
    // link: "/graphic_designing_3DModel" 
  }

];

const QuranPopularCourses = () => {
  const navigate = useNavigate();

  const handleBookDemoClick = () => {
    navigate("/BookADemo");
  };
  return (
    <>
      <Helmet>
        <title>Qur'an Learning for Kids Online | Easy & Meaningful -- Polymath-Kids</title>
        <meta name="description" content="Polymath-Kids makes Qur'an learning easy & meaningful for kids. Nurture faith, morals & spirituality through engaging lessons with caring teachers." />
      </Helmet>

      <div className="stem-container">
        <h1 className="stem-title-1">Explore Our Fun & Skill-Boosting </h1>
        <h1 className="stem-title">Quran Courses</h1>
        <div className="courses-grid">
          {courses.map((course) => (
            <div key={course.title} className="course-card">
              <Link to={course.link} className="course-link">

                <div className="course-image-container">
                  <img
                    src={`${API_CONFIG.IMAGES_URL}/${course.image}`}
                    alt={course.title}
                    className="course-image"
                  />
                  <span className="ages-badge">{course.age}</span>
                </div>

                <div className="icon-container" style={{ backgroundColor: course.color }}>
                  <img src={`${API_CONFIG.IMAGES_URL}/${course.icon}`} alt={`${course.title} icon`} className="course-icon" />
                </div>

                <p className="course-title">{course.title}</p>
              </Link>
            </div>
          ))}
        </div>
        <button className="pocustom-btn yellow-btn" onClick={handleBookDemoClick}>
          <img src={`${API_CONFIG.IMAGES_URL}/Polymath-images/pencil.png`} alt="icon" className="pobtn-icon" />
          Book Free Demo Class
        </button>
      </div>
    </>
  );
};
const QuranPortal = () => {
  const quranpage = heroContent.quranpage;
  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
        leftImg={"Polymath-images/quranLeftImg.png"}
        rightImg={'Polymath-images/quranRightImg.png'}
        titlePart1="Qur'an Learning Made Easy"
        titlePart2="and Meaningful for Kids"
        description="Being a parent is a beautiful blessing-and with it comes the sacred responsibility of nurturing your child's moral, spiritual, and emotional development. At Polymath-Kids, we believe the greatest gift you can offer your child is a strong connection to Allah Almighty through the Qur'an."
        button1Text={false}
        button2Text="Book Free Demo Class"
        button1Icon={'Polymath-images/pencil.png'}
        button2Icon={'Polymath-images/pencil.png'}
        onButton1Click={() => alert("Early bird discount clicked!")}
        onButton2Click={() => alert("Book demo clicked!")}
      />
      <QuranPopularCourses />

      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default QuranPortal;
